<script lang="ts">
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-nocheck
    import { defineComponent } from 'vue';
    // import { defineAsyncComponent } from 'vue';
    import Swal from 'sweetalert2';
    import axios from 'axios';
    import '@fortawesome/fontawesome-free/css/all.min.css';
    import { Solicitud2 } from '@/main';
    // import { Solicitud } from '@/main';


    export default defineComponent({
        components: {  
            // HoverNivel: defineAsyncComponent(() => import('./components/HoverNivel.vue')),
            // EgresadosVid: defineAsyncComponent(() => import('./components/egresadosVid.vue'))
        },
        data() {
            return {
                //datos para los formularios
                tokenizer: "",
                selectedState: '',
                selectedCampus: "",
                states: [
                    'Baja California', 'Chihuahua', 'Ciudad de México', 'Estado de México', 
                    'Jalisco', 'Nuevo León', 'Puebla', 'Querétaro', 'Quintana Roo', 'Yucatán', 'Modalidad'
                ],

                // Base de datos de tus campus con su respectivo estado
                allCampuses: [
                    { value: 'tijuana', label: 'Tijuana', state: 'Baja California' },
                    { value: 'chihuahua', label: 'Chihuahua', state: 'Chihuahua' },
                    { value: 'del-valle', label: 'Colonia Del Valle, CDMX', state: 'Ciudad de México' },
                    { value: 'santa-fe', label: 'Santa Fe, CDMX', state: 'Ciudad de México' },
                    { value: 'los-reyes', label: 'Los Reyes, La Paz', state: 'Estado de México' },
                    { value: 'presa-madin', label: 'Presa Madín', state: 'Estado de México' },
                    { value: 'guadalajara', label: 'Guadalajara', state: 'Jalisco' },
                    { value: 'monterrey', label: 'Monterrey', state: 'Nuevo León' },
                    { value: 'angelopolis', label: 'Angelópolis, Puebla', state: 'Puebla' },
                    { value: 'queretaro', label: 'Querétaro', state: 'Querétaro' },
                    { value: 'cancun', label: 'Cancún', state: 'Quintana Roo' },
                    { value: 'riviera-maya', label: 'Riviera Maya', state: 'Quintana Roo' },
                    { value: 'merida', label: 'Mérida', state: 'Yucatán' },
                    { value: 'virtual-mex', label: 'Virtual', state: 'Modalidad' }
                ],
                clave: "",
                studyTypeList: [] as string[], // Lista de niveles educativos
                selectedStudyType: "",
                offerList: [] as string[], // Lista de ofertas educativas
                selectedOffer: "",
                modelList: [] as string[], // Lista de modelos educativos
                selectedModel: "",
                campusData: {}, // Objeto para almacenar los datos del campus
                toast : Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    width: 500,
                    padding: '1em',
                    showConfirmButton: false,
                    timerProgressBar: true,
                    timer: 4000,
                    icon: 'error',
                    iconColor: '#881912'
                }),

                nombre: '',
                apellidos: '',
                email: '',
                telefono: '',
                comentario: '',
                currentStep: 1,

                // Estados para manejar errores y validaciones
                nombreError: '',
                apellidosError: '',
                emailError: '',
                telefonoError: '',
                urlW: '',
            };
        },
        computed: {
            // Esta función se encarga de filtrar los campus en tiempo real
            filteredCampuses(): Array<{ value: string, label: string, state: string }> {
                if (!this.selectedState) return [];
                return this.allCampuses.filter(campus => campus.state === this.selectedState);
            }
        },
        methods: {
            async updateOptions(section: any) {
                await this.loadData(section);
            },

            onChangeState() {
                this.selectedCampus = '';
            },

            async loadData(section: string) {
                try {
                    // --- INICIO DE LA CORRECCIÓN ---
                    // El 'import' dinámico no funciona con 'public'. Usamos 'fetch'.

                    // 1. Construye la ruta al archivo en la carpeta 'public'
                    const path = `/assets/json/${this.selectedCampus}.json`;

                    // 2. Usa fetch() para obtener el archivo
                    const response = await fetch(path);

                    // 3. Verifica si la solicitud fue exitosa (ej. 404 si no lo encuentra)
                    if (!response.ok) {
                        throw new Error(`Error HTTP ${response.status}: No se pudo encontrar ${path}`);
                    }

                    // 4. Convierte la respuesta a JSON.
                    // Esta variable 'campusData' ya es tu objeto JSON,
                    // reemplaza directamente a 'campusModule.default'
                    const campusData = await response.json();
                    
                    // --- FIN DE LA CORRECCIÓN ---


                    // Verifica la sección y carga los datos correspondientes
                    // (TODA TU LÓGICA SIGUIENTE PERMANECE IDÉNTICA)
                    if (section === 'studyType') {
                        this.selectedStudyType= "";
                        this.selectedOffer = "";
                        this.selectedModel = "";
                        this.studyTypeList = [];
                        this.offerList = [];
                        this.modelList = [];
                        // Carga los tipos de estudios para el campus seleccionado
                        //@ts-ignore
                        this.studyTypeList = Object.keys(campusData);
                    
                    } else if (section === 'offer') {
                        this.selectedOffer = "";
                        this.selectedModel = "";
                        this.offerList = [];
                        this.modelList = [];
                        // Lógica para cargar datos de oferta 
                        //@ts-ignore
                        this.offerList = campusData[this.selectedStudyType].map((item: { oferta: any; }) => item.oferta);
                    } else if (section === 'model') {
                        this.selectedModel = "";
                        this.modelList = [];
                        // Lógica para cargar datos de modelo 
                        //@ts-ignore
                        this.modelList = campusData[this.selectedStudyType].find((item: { oferta: any; }) => item.oferta === this.selectedOffer).nivel.map((item: { name: any; }) => item.name);
                    } else if (section === 'clv') {
                        const nivelSeleccionado = this.selectedModel; 
                        //@ts-ignore
                        const nivelObject = campusData[this.selectedStudyType].find((item: { oferta: any; }) => item.oferta === this.selectedOffer)
                            //@ts-ignore
                            .nivel.find((nivel: { name: any; }) => nivel.name === nivelSeleccionado);

                        // Asigna el valor de la propiedad 'key' a la variable global clave
                        //@ts-ignore
                        this.clave = nivelObject.key;
                    }
                } catch (error) {
                    // Maneja errores en la carga de datos
                    console.error('Error al cargar datos de la sección', section, error);
                }
            },
            mostrarErrorSweetAlert(mensaje: string) {
                this.toast.fire({
                    icon: 'error',
                    title: 'Error de validación',
                    text: mensaje,
                });
            },
            currentUrl() {
                console.log(window.location.href)
                return window.location.href;
            },
            // validarDatos(){
            //     if(!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{1,30}$/.test(this.nombre)){
            //         this.nombreError = 'Ingrese un nombre válido.';
            //         this.mostrarErrorSweetAlert(this.nombreError);
            //     } else {
            //         if(!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{1,55}$/.test(this.apellidos)){
            //             this.apellidosError = 'Por favor ingresa un(os) apellido(s) válido(s)..';
            //             this.mostrarErrorSweetAlert(this.apellidosError);
            //         } else {
            //             if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)){
            //                 this.emailError = 'Ingrese un correo electrónico válido.';
            //                 this.mostrarErrorSweetAlert(this.emailError);
            //             } else {
            //                 if(!/^\d{10}$/.test(this.telefono)){
            //                     this.telefonoError = 'Ingrese un número de teléfono válido (10 dígitos).';
            //                     this.mostrarErrorSweetAlert(this.telefonoError);
            //                 } else {
            //                     return true
            //                 }
            //             }
            //         }
            //     }
            //     return false;
            // },

            validarDatos2() {
                // Validar campo nombre
                if (!this.nombre.trim()) {
                    this.nombreError = 'El campo nombre no puede estar vacío.';
                    this.mostrarErrorSweetAlert(this.nombreError);
                    return false;
                } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{1,30}$/.test(this.nombre)) {
                    const caracterInvalido = this.nombre.match(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/);
                    this.nombreError = `El nombre contiene caracteres no válidos: "${caracterInvalido}". Solo se permiten letras y espacios (1-30 caracteres).`;
                    this.mostrarErrorSweetAlert(this.nombreError);
                    return false;
                }

                // Validar campo apellidos
                if (!this.apellidos.trim()) {
                    this.apellidosError = 'El campo apellidos no puede estar vacío.';
                    this.mostrarErrorSweetAlert(this.apellidosError);
                    return false;
                } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{1,55}$/.test(this.apellidos)) {
                    const caracterInvalido = this.apellidos.match(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/);
                    this.apellidosError = `Los apellidos contienen caracteres no válidos: "${caracterInvalido}". Solo se permiten letras y espacios (1-55 caracteres).`;
                    this.mostrarErrorSweetAlert(this.apellidosError);
                    return false;
                }

                // Validar campo email
                if (!this.email.trim()) {
                    this.emailError = 'El campo correo electrónico no puede estar vacío.';
                    this.mostrarErrorSweetAlert(this.emailError);
                    return false;
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                    this.emailError = 'Ingrese un correo electrónico válido en formato ejemplo@dominio.com.';
                    this.mostrarErrorSweetAlert(this.emailError);
                    return false;
                }

                // Validar campo teléfono
                if ( this.telefono.length < 10) {
                    this.telefonoError = 'El campo teléfono debe tener una longitud de 10 dígitos numéricos.';
                    this.mostrarErrorSweetAlert(this.telefonoError);
                    return false;
                } else if (!/^\d{10}$/.test(this.telefono)) {
                    const caracterInvalido = this.telefono.match(/[^\d]/);
                    this.telefonoError = `El teléfono contiene caracteres no válidos: "${caracterInvalido}". Solo se permiten dígitos numéricos.`;
                    this.mostrarErrorSweetAlert(this.telefonoError);
                    return false;
                }

                return true;
            },

            validaDatosCarrera() {
                if ( !this.selectedCampus ) {
                    this.mostrarErrorSweetAlert('Por favor elige el campus de interés.' );
                } else {
                    if ( !this.selectedStudyType ) {
                        this.mostrarErrorSweetAlert('Por favor elige un nivel de estudio.');
                    }  else {
                        if(!this.selectedOffer){
                            this.mostrarErrorSweetAlert('Por favor elige una oferta educativa.');
                        } else {
                            if ( !this.selectedModel ) {
                            this.mostrarErrorSweetAlert('Por favor elige un modelo académico.');
                            }  else {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            nextStep() {
                if(this.currentStep === 1){
                    this.validarDatos2()          
                    if (
                        this.validarDatos2()
                    ) {
                        this.currentStep += 1;
                    }
                } else if (this.currentStep === 2) {
                    this.validaDatosCarrera()          
                    if (
                        this.validaDatosCarrera()
                    ) {
                        this.currentStep += 1;
                    }
                }
            },
            prevStep() {
                this.currentStep -= 1;
            },
            handleEmailChange() {
                if (!this.tokenizer) {
                    this.executeRecaptcha();
                }
            },
            executeRecaptcha() {
                //@ts-ignore
                grecaptcha.enterprise.execute('6Ldd0x0oAAAAAAaPVjMnVirgyfT6qahpksCqN0UX', { action: 'submit_lead' })
                    .then((token: any) => {
                    this.tokenizer = token;
                    })
                    .catch((error: any) => {
                    console.error('Error al ejecutar reCAPTCHA:', error);
                    });
            },
            submitForm() {
                // Validar el formulario antes de enviar los datos
                if (this. validaDatosCarrera()&&this.validarDatos2()) {
                    // Crear un objeto FormData con los datos del formulario
                    // console.log(this.currentUrl())
                    const formData = new FormData();
                    formData.append('nombre', this.nombre);
                    formData.append('apellidos', this.apellidos);
                    formData.append('email', this.email);
                    formData.append('telefono', this.telefono);
                    formData.append('nivel', this.selectedStudyType);
                    formData.append('campus', this.selectedCampus);
                    formData.append('modelo', this.selectedModel);
                    formData.append('carrera', this.clave);
                    formData.append('g-recaptcha-response',this.tokenizer)
                    formData.append('mensaje', this.comentario)
                    formData.append('url', this.currentUrl())
                    /* Realizar la solicitud POST
                    let peticion = {
                        method: 'POST',
                        body: formData,
                    };*/
                    Swal.fire({
                        title: 'ENVIANDO...',
                        text: 'ESTAMOS ENVIANDO SUS DATOS. NO CIERRE LA VENTANA',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            // @ts-ignore
                            Swal.showLoading();
                            axios.post(Solicitud2, formData, {
                            // axios.post(Solicitud, formData, {
                                headers: {'Content-Type': 'multipart/form-data',},
                                responseType: 'json', // Asegúrate de incluir esta línea
                            })
                                .then((response: { data: { error: any; descripcion: any; }; }) => {
                                        // if (response.data.error === false) {
                                            //@ts-ignore
                                            console.log(response);
                                            // if (dataLayer) {
                                            //     //@ts-ignore
                                            //     dataLayer.push({
                                            //     event: 'generate_lead',
                                            //     email: this.email,
                                            //     career: this.selectedOffer,
                                            //     });
                                            // }
                                            Swal.fire({
                                                title: '¡ENVIADO!',
                                                text: 'NUESTROS EJECUTIVOS SE PONDRÁN EN CONTACTO CONTIGO LO ANTES POSIBLE.',
                                                icon: 'success',
                                                iconColor: '#CAAB55',
                                                showConfirmButton: false,
                                                timer: 4000
                                            });
                                            this.nombre = '';
                                            this.apellidos = '';
                                            this.email = '';
                                            this.telefono = '';
                                            this.tokenizer = '';
                                            this.selectedStudyType= "";
                                            this.selectedOffer = "";
                                            this.selectedModel = "";
                                            this.selectedCampus = "";
                                            this.studyTypeList = [];
                                            this.offerList = [];
                                            this.modelList = [];
                                            this.prevStep()
                                            this.prevStep()
                                        // } else {
                                        //     Swal.fire({
                                        //         text: `${response.data.descripcion}`,
                                        //         icon: "error",
                                        //         iconColor: '#881912',
                                        //         showConfirmButton: false,
                                        //         timer: 4000
                                        //     });
                                        //     this.tokenizer='';
                                        // }
                                }).catch( (error: any) => console.log('error', error) );
                        }
                    });
                }
            },
        },
    });
</script>

<template>
    <div class="flex flex-col mt-[88px] lg:mt-[143px] bg-white w-full items-center justify-center">
        <!-- Banner -->
        <section class="w-full flex flex-col items-center justify-center md:px-0">
            <img src="/pagesImages/Banner-contactanos-LEON-querer-es-poder.webp" alt="QUERER ES PODER" class="border border-gray-400 w-full hidden md:block">
            <div class="aspect-square max-w-[500px] max-h-[500px] mb-12">
                <img src="/pagesImages/banner-contacto-movil-LEON-querer-es-poder.webp" alt="¡Descubre lo que Humanitas ofrece para ti!" class="w-full md:hidden object-cover">
            </div>
            <h1 class="sr-only">Contáctanos Universidad Humanitas</h1>
            <div class="flex flex-col w-full mb-8">
                <p class="text-gray-500 text-[24px]">Contáctanos.</p>
                <p class="text-hgold font-serif text-[38px] md:text-[36px]">Te responderemos a la brevedad.</p>
            </div>
        </section>
        <!-- Div del formulrio -->
        <div class="flex flex-col w-full justify-center items-center">
            <div class="lg:flex items-center justify-center border bg-white p-2 md:p-16 max-w-4xl lg:max-w-5xl w-full border-gray-200">
                <div class="login-box form-container border border-black w-full lg:m-20 ml-0 relative z-10">
                    <h2 class="sr-only">Formulario</h2>
                    <div id="contactForm" @submit.prevent="" class="">
                        <div v-if="currentStep === 1">
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-user pr-2"></i>
                                <input type="text" name="nombre" id="nombre" v-model="nombre" required maxlength="55" class="focus:ring-0 ml-[25px]">
                                <label class="ml-[25px]">Nombre</label>
                            </div>
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-user pr-2"></i>
                                <input type="text" name="apellidos" id="apellidos" v-model="apellidos" required maxlength="55" class="focus:ring-0 ml-[25px]">
                                <label class="ml-[25px]">Apellidos</label>
                            </div>
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-envelope"></i>
                                <input type="email" name="email" id="email" v-model="email" @change="handleEmailChange" required class="focus:ring-0 ml-[25px]">
                                <label class="ml-[25px]">Email</label>
                            </div>
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-phone"></i>
                                <input type="tel" name="telefono" id="telefono" v-model="telefono" required maxlength="10" class="focus:ring-0 ml-[25px]">
                                <label class="ml-[25px]">Tel&eacute;fono</label>
                            </div>
                            <button @click.prevent="nextStep" class="hover:bg-hwine focus:outline-none rounded-none text-white bg-hgold hover:text-white">Siguiente</button>
                        </div>

                            <!-- Segunda parte del formulario -->
                        <div v-if="currentStep === 2">
                            <h2>Informaci&oacute;n Acad&eacute;mica</h2>
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-map-marker-alt"></i>
                                <select name="campus" id="campus" v-model="selectedCampus" @change="updateOptions('studyType')" required class="focus:ring-0 ml-[25px]">
                                    <option class="text-[#797979]" value="">Selecciona una opci&oacute;n</option>
                                    <optgroup label="Baja California">
                                        <option class="text-[#797979]" value="tijuana">Tijuana</option>
                                    </optgroup>
                                    <optgroup label="Chihuahua">
                                        <option class="text-[#797979]" value="chihuahua">Chihuahua</option>
                                    </optgroup>
                                    <optgroup label="Ciudad de México">
                                        <option class="text-[#797979]" value="del-valle">Del Valle</option>
                                        <option class="text-[#797979]" value="santa-fe">Santa Fe</option>
                                    </optgroup>
                                    <optgroup label="Estado de México">
                                        <option class="text-[#797979]" value="los-reyes">Los Reyes, La Paz</option>
                                        <option class="text-[#797979]" value="presa-madin">Presa Mad&iacute;n</option>
                                    </optgroup>
                                    <optgroup label="Jalisco">
                                        <option class="text-[#797979]" value="guadalajara">Guadalajara</option>
                                    </optgroup>
                                    <optgroup label="Nuevo León">
                                        <option class="text-[#797979]" value="monterrey">Monterrey</option>
                                    </optgroup>
                                    <optgroup label="Puebla">
                                        <option class="text-[#797979]" value="angelopolis">Angelópolis</option>
                                    </optgroup>
                                    <optgroup label="Querétaro">
                                        <option class="text-[#797979]" value="queretaro">Quer&eacute;taro</option>
                                    </optgroup>
                                    <optgroup label="Quintana Roo">
                                        <option class="text-[#797979]" value="cancun">Canc&uacute;n</option>
                                        <option class="text-[#797979]" value="riviera-maya">Riviera Maya</option>
                                    </optgroup>
                                    <optgroup label="Yucatán">
                                        <option class="text-[#797979]" value="merida">M&eacute;rida</option>
                                    </optgroup>
                                    <option class="text-[#797979] font-bold" value="virtual-mex">Virtual</option>
                                </select>
                                <label class="ml-[25px]" style="top: -20px;left: 0;color: #CAAB55;font-size: 12px;">Campus de Inter&eacute;s</label>
                            </div>
                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-graduation-cap"></i>
                                <select
                                    name="nivelEducativo"
                                    id="nivelEducativo"
                                    v-model="selectedStudyType"
                                    @change="updateOptions('offer')"
                                    required
                                    class="focus:ring-0 ml-[25px]"
                                >
                                    <option class="text-[#797979]" value="" disabled>Selecciona una opci&oacute;n</option>
                                    <option class="text-[#797979]" v-for="studyType in studyTypeList" :key="studyType" :value="studyType">
                                    {{ studyType }}
                                    </option>
                                </select>
                                <label class="ml-[25px]" style="top: -20px;left: 0;color: #CAAB55;font-size: 12px;">Nivel Educativo</label>
                            </div>

                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-book"></i>
                                <select
                                    type="text"
                                    name="ofertaEducativa"
                                    id="ofertaEducativa"
                                    v-model="selectedOffer"
                                    @change="updateOptions('model')"
                                    required
                                    class="focus:ring-0 ml-[25px]"
                                >
                                    <option class="text-[#797979]" value="" disabled>Selecciona una opci&oacute;n</option>
                                    <option class="text-[#797979]" v-for="offer in offerList" :key="offer" :value="offer">
                                    {{ offer }}
                                    </option>
                                </select>
                                <label class="ml-[25px]" style="top: -20px;left: 0;color: #CAAB55;font-size: 12px;">Oferta Educativa</label>
                            </div>

                            <div class="user-box mb-2 mr-2">
                                <i class="fas fa-cogs"></i>
                                <select
                                    name="modeloEducativo"
                                    id="modeloEducativo"
                                    v-model="selectedModel"
                                    @change="updateOptions('clv')"
                                    required
                                    class="focus:ring-0 ml-[25px]"
                                >
                                    <option class="text-[#797979]" value="" disabled>Selecciona una opci&oacute;n</option>
                                    <option class="text-[#797979]" v-for="model in modelList" :key="model" :value="model">
                                    {{ model }}
                                    </option>
                                </select>
                                <label
                                    class="ml-[25px]"
                                    style="top: -20px;left: 0;color: #CAAB55;font-size: 12px;">Modelo Educativo</label>
                            </div>
                            <button @click.prevent="prevStep" class="hover:bg-hwine focus:outline-none text-white rounded-none m-4 bg-hgold hover:text-white">Anterior</button>
                            <button @click.prevent="nextStep" class="hover:bg-hwine focus:outline-none text-white rounded-none m-4 bg-hgold hover:text-white">Siguiente</button>
                        </div>

                        <!-- Tercera parte del formulario -->
                        <div v-if="currentStep === 3">
                            <h2>Comentarios (Opcional)</h2>
                            <div class="user-box mr-2 mb-2">
                                <i class="fas fa-comment"></i>
                                <textarea name="mensaje" id="mensaje" v-model="comentario" rows="5" class="focus:ring-0 ml-[25px]"></textarea>
                                <label class="ml-[25px]" style="top: -20px;left: 0;color: #CAAB55;font-size: 12px;">Mensaje (Opcional)</label>
                            </div>
                            <button @click.prevent="prevStep" class="hover:bg-hwine focus:outline-none text-white rounded-none m-4 bg-hgold hover:text-white">Anterior</button>
                            <button @click.prevent="submitForm" class="hover:bg-hwine focus:outline-none text-white rounded-none m-4 bg-hgold hover:text-white">¡Quiero Saber M&aacute;s!</button>
                        </div>
                    </div>
                </div>
                <div class="bg-[#F3F2F2] border lg:ml-16 w-full border-gray-300 flex flex-col items-center justify-center">
                    <h2>
                        <span class="text-[22px] mt-4 leading-tight text-gray-700 block" >Beneficios de estudiar en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="lg:text-[28px] text-[28px] mb-2 font-serif text-hwine block">Universidad Humanitas</span>
                    </h2>
                    <div class="flex items-center justify-center">
                        <p class="text-sm text-left mx-6 mb-4 mt-4">
                            1. Sin cuota de inscripción.<br><br>
                            2. Colegiaturas accesibles.<br><br>
                            3. Modalidades de estudio: Ejecutivo, Escolarizado y Virtual.<br><br>
                            4. Planes académicos diseñados para el éxito profesional.<br><br>
                            5. Validación ante la Secretaría de Educación Pública (SEP).<br><br>
                            6. Instalaciones de primer nivel.<br><br>
                            7. Programas de Becas.<br><br>
                            8. Bolsa de trabajo.<br><br>
                            9. Programas de voluntariado enfocados a la responsabilidad social.<br><br>
                            10. English Kingdom certificado por la Universidad de Cambridge.<br><br>
                        </p>
                    </div>
                    <div class="flex justify-center mx-auto w-[60%] mb-4">
                        <div class="flex justify-start">
                            <a href="https://api.whatsapp.com/send?phone=5215611422526" target="_blank">
                                <img src="/pagesImages/whats-button.png" alt="Contacto vía WhastsApp" class="">
                            </a>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .login-box {
        margin: 0 1px;
        padding: 25px;
        box-sizing: border-box;
        border: black;
        border-radius: 0px;
        
        z-index: 1;
    }

    .login-box h2 {
        margin: 0 0 30px;
        padding: 0;
        color: #fff;
        text-align: center;
    }

    .login-box .user-box {
        position: relative;
        z-index: 1;
    }

    .login-box .user-box i {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 10px;
        color: #CAAB55;
    }

    .form-container {
        position: relative;
        z-index: 1;
    }

    .login-box .user-box input,
    .login-box .user-box select,
    .login-box .user-box textarea {
        width: 100%;
        appearance: auto;
        padding: 10px 10px; /* Ajusta según tu preferencia */
        font-size: 16px;
        color: #797979;
        margin-bottom: 30px;
        border: none;
        border-bottom: 1px solid #CAAB55;
        outline: none;
        background: transparent;
    }

    

    .login-box .user-box label {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        padding: 10px 0;
        font-size: 16px;
        color: black;
        pointer-events: none;
        transition: .5s;
    }

    .login-box .user-box input:focus ~ label,
    .login-box .user-box input:valid ~ label,
    .login-box .user-box select:focus ~ label,
    .login-box .user-box textarea:focus ~ label {
        top: -25px;
        left: 0;
        color: #CAAB55;
        font-size: 12px;
    }

    .custom-button {
        display: inline-block;
        padding: 10px 20px;
        color: white;
        z-index: 1;
        font-size: 16px;
        text-decoration: none;
        text-transform: uppercase;
        margin-top: 40px;
        letter-spacing: 4px;
        background: #881912;
        border: 1px solid #881912;
        border-radius: 5px;
        color: white;
        transition: background-color 0.3s, color 0.3s;
    }

    .custom-button:hover {
        background-color: #CAAB55;
        color: #fff;
    }

    .login-box .user-box input.error-border,
    .login-box .user-box select.error-border,
    .login-box .user-box textarea.error-border {
        border-bottom: 1px solid #FF0000 !important;
    }

    .login-box .user-box label.error{
        color: #FF0000;
        font-size: 12px;
    }
</style>